import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=7a4b9b19&"
import script from "./zone.vue?vue&type=script&lang=ts&"
export * from "./zone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports